import { extendCrudApiByHousehold } from '@/utils/api.js';

const emojisApi = extendCrudApiByHousehold({
  entityNameSingular: 'Emoji',
  entityNamePlural: 'Emojis',
  entityPath: 'emojis',
  extraEndpoints: (builder) => ({
    uploadEmoji: builder.mutation({
      query: ({ householdId, file }) => {
        const formData = new FormData();
        formData.append("file", file);
        return {
          url: `/h/${householdId}/emojis/upload`,
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: (result, error, arg) => [{ type: 'Emojis', id: 'LIST', householdId: arg.householdId }],
    }),
  }),
});

export const {
  useGetEmojisQuery,
  useUploadEmojiMutation,
  useCreateEmojiMutation,
  useDeleteEmojiMutation,
} = emojisApi;

